export const EventStatus = {
    EventWithResults: "EventWithResults",
    EventWithoutResults: "EventWithoutResults",
    FutureEvent: "FutureEvent",
    EventInProgress: "EventInProgress"
};